import { Skeleton } from "components/ui/skeleton";

export default function SkeletonEditMusicInformation() {
  return (
    <div className="pb-8">
      <div className="grid grid-cols-12">
        <div className="col-span-6 mx-2 space-y-2">
          <Skeleton className="w-20 h-4" />
          <Skeleton className="w-full h-8" />
        </div>
        <div className="col-span-4 mx-2 space-y-2">
          <Skeleton className="w-20 h-4" />
          <Skeleton className="w-full h-8" />
        </div>
      </div>

      <div className="grid grid-cols-2">
        <div className="mx-2 space-y-2 mt-2">
          <Skeleton className="w-20 h-4" />
          <Skeleton className="w-full h-8" />
        </div>

        <div className="mx-2 space-y-2 mt-2">
          <Skeleton className="w-20 h-4" />
          <Skeleton className="w-full h-8" />
        </div>
      </div>

      <div className="mx-2 space-y-2 mt-2">
        <Skeleton className="w-20 h-4" />
        <Skeleton className="w-full h-8" />
      </div>

      <div className="mx-2 mt-4">
        <Skeleton className="w-20 h-4" />
        <div className="flex flex-wrap">
          {[...Array(20)].map((_: any, index: number) => {
            return <Skeleton key={index} className="w-20 h-8 me-2 mt-2" />;
          })}
        </div>
      </div>

      <div className="mx-2 mt-4">
        <Skeleton className="w-20 h-4" />
        <div className="flex flex-wrap">
          {[...Array(20)].map((_: any, index: number) => {
            return <Skeleton key={index} className="w-20 h-8 me-2 mt-2" />;
          })}
        </div>
      </div>
    </div>
  );
}
